import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CustomButton } from "../components/atoms/CustomButton";
import { HiOutlineLockClosed } from "react-icons/hi";
import SecureStorage from "../utils/secureStorage";

const ImpersonationEnded: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    SecureStorage.clearImpersonationSession();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-gray-100">
      <div className="max-w-md w-full bg-white rounded-lg border border-gray-200 p-8 text-center">
        <div className="w-16 h-16 mx-auto mb-6 bg-amber-100 rounded-full flex items-center justify-center">
          <HiOutlineLockClosed className="w-8 h-8 text-amber-600" />
        </div>
        <h1 className="text-xl font-semibold text-gray-900 mb-2">
          {t("rootConsole.impersonation.endedTitle")}
        </h1>
        <p className="text-sm text-gray-500 mb-6">
          {t("rootConsole.impersonation.endedDescription")}
        </p>
        <CustomButton
          variant="primary"
          className="mx-auto"
          onClick={() => window.close()}
          title={t("rootConsole.impersonation.closeTab") as string}
        />
      </div>
    </div>
  );
};

export default ImpersonationEnded;
